var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-wrapper"},[_c('div',[_c('h1',{staticClass:"error-title"},[_vm._v("致命错误")]),_c('p',{staticClass:"error-desc"},[_vm._v("请重新启动应用或联系管理员")])])])
}]

export { render, staticRenderFns }